import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SocketContext, createClient as createSocket } from '@exonet/api-socket-client';
import boost from 'app/client/utilities/hoc/boost';

// Connect to the socket.

// Store.
import store from './store';

/**
 * Connect to the socket through the socket provider.
 *
 * @param {string|boolean} token The token to connect or false.
 * @param {*} children The content to render.
 *
 * @returns {Element} The content with a socket provider.
 */
const SocketProvider = ({ token, children }) => {
  const [socketClient, setSocketClient] = useState(null);

  // Only with a token, which a session short of MFA lacks. In an effect: the client
  // connects on construction, so a discarded render would leak it.
  useEffect(() => {
    if (!token) {
      setSocketClient(null);

      return undefined;
    }

    const client = createSocket(__API_SOCKET_URL__, { token });
    setSocketClient(client);

    return () => client.disconnect();
  }, [token]);

  return <SocketContext.Provider value={socketClient}>{children}</SocketContext.Provider>;
};

SocketProvider.propTypes = {
  token: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.element.isRequired,
};

export default boost({ store })(SocketProvider);
